import http from '@/services/http'

export const SET_LIST_TIPOS_ATIVIDADE = 'setListTiposAtividade'
export const SET_LIST_PLANILHA = 'setListPlanilha'
export const SET_PLANILHA = 'setPlanilha'
export const SET_TIPO_ATIVIDADE = 'setTipoAtividade'
export const SET_TIPOS_ATIVIDADE_NEW = 'setAtividadeNew'
export const SET_TIPOS_ATIVIDADE_UPDATE = 'setAtividadeUpdate'
export const SET_TIPOS_ATIVIDADE_DELETE = 'setAtividadeDelete'
export const SET_MESSAGE_ALERT = 'setMessage'
export const SET_COLUNAS = 'setColunas'

const actions = {

    async listar_tipos_atividade(context) {
        await http.get('tipo-atividade')
            .then(response => context.commit(SET_LIST_TIPOS_ATIVIDADE, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    async create_tipo_atividade(context, value) {
        let message = await http.post('tipo-atividade', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
        context.commit(SET_TIPOS_ATIVIDADE_NEW, message.message.conteudo)
        console.log(message.message)
    },
   
    async update_tipo_atividade(context, value) {
        let data = await http.put('tipo-atividade/' + value.id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
        context.commit(SET_TIPOS_ATIVIDADE_UPDATE, data.message.conteudo)
    },

    async delete_tipo_atividade(context, value) {
        let data = await http.delete('tipo-atividade/' + value.id)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, data)
        context.commit(SET_TIPOS_ATIVIDADE_DELETE, value)
    },
    async listar_colunas(context) {
        await http.get('tipo-atividade/colunas')
            .then(response => context.commit(SET_COLUNAS, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    set_tipo_atividade(context, value) {
        context.commit(SET_TIPO_ATIVIDADE, value)
    },
};
const mutations = {

    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {
            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
    [SET_LIST_TIPOS_ATIVIDADE](state, value) {
        state.lista_tipos_atividade = value
    },
 
    [SET_TIPO_ATIVIDADE](state, value) {
        state.tipo_atividade_tab = value
    },
    [SET_TIPOS_ATIVIDADE_NEW](state, value) {
        state.lista_tipos_atividade.push(value)
    },
    [SET_TIPOS_ATIVIDADE_UPDATE](state, value) {
        state.lista_tipos_atividade = state.lista_tipos_atividade.map(i => i.id === value.id ? { ...i, ...value } : i);
    },
    [SET_TIPOS_ATIVIDADE_DELETE](state, value) {
        state.lista_tipos_atividade = state.lista_tipos_atividade.filter(
            (tipo_atividade) => tipo_atividade.id !== value.id
        );
    },
    [SET_COLUNAS](state, value) {
        state.lista_colunas = value
    },

};
const getters = {}

const state = {
    mensagem_alert: [],
    lista_tipos_atividade: [],
    tipo_atividade: [],
    lista_colunas: [],
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
